import { ApiTags, rootApi } from '../../../../../services/rootApi';
import { FPXBankListResponse, IFPXBankHashRequest, IFPXHashResponse } from './models';

const TAG = ApiTags.Payment;

const fpxBankApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getFPXHash: builder.mutation<IFPXHashResponse, IFPXBankHashRequest>({
      query: (model) => ({
        url: '/Payments/FPXBank',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    }),

    getBankListHash: builder.mutation<FPXBankListResponse, void>({
      query: (model) => ({
        url: '/Payments/FPXBankList',
        method: 'POST',
        body: model
      }),
      invalidatesTags: [TAG]
    })

  })
})

export const {
  useGetFPXHashMutation,
  useGetBankListHashMutation,
} = fpxBankApi;